import { Link } from "react-router-dom"

const CtaSection = () => {

  const handleScrollContact = () => {
    setTimeout(() => {
      const element = document.querySelector("#contactComponent")
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }
    }, 100)
  }

  return (
    <section className="cta-section">
      <div className="container">

        <div className="cta-box text-center mx-auto">

          <h2 className="cta-title fw-bolder text-white">
            ¿Listo para empezar tu viaje en Talara?
          </h2>

          <p className="cta-text text-white mt-3">
            Reserva hoy mismo y disfruta de las tarifas más competitivas del mercado
            en Talara con la mejor flota de autos disponible.
          </p>

          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-4">

            <Link
              to="/"
              className="btn fw-bold px-4 py-2"
              style={{ color: '#d22222', backgroundColor: 'white', border: '2px solid #d22222' }}
            >
              Cotiza Ahora
            </Link>

            <Link
              to="/#contactComponent"
              onClick={handleScrollContact}
              className="btn fw-bold px-4 py-2"
              style={{ color: 'white', backgroundColor: 'transparent', border: '2px solid white' }}
            >
              Contáctanos
            </Link>

          </div>

        </div>

      </div>

      <style>
        {`
        .cta-section{
          background:#ffffff;
          padding:3rem 0;
        }

        .cta-box{
          background:#d22222;
          border-radius:25px;
          padding:60px 30px;
          max-width:1000px;
        }

        .cta-title{
          font-size:2rem;
        }

        .cta-text{
          max-width:650px;
          margin:auto;
          font-size:1rem;
        }

        @media (min-width:768px){
          .cta-title{
            font-size:2.5rem;
          }

          .cta-text{
            font-size:1.1rem;
          }
        }

        @media (min-width:1200px){
          .cta-title{
            font-size:3rem;
          }
        }
        `}
      </style>

    </section>
  )
}

export default CtaSection